import React from 'react';
import CenteredOverlay from './CenteredOverlay.react';
import PlayPause from './PlayPause.react';

class StartOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.timeoutHandle = setTimeout(() => {
      this.setState({visible: true});
    }, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle);
  }

  render() {
    if (!this.state.visible) return null;
    var style = {};
    if (this.props.posterUrl) {
      style.background = `url(${this.props.posterUrl})`;
      style.backgroundSize = 'cover';
    }

    return (
      <CenteredOverlay className='b-start-overlay' style={style}>
        <PlayPause onClick={this.props.playCallback} onTouchEnd={this.props.playCallback} />
      </CenteredOverlay>
    );
  }
}

export default StartOverlay;
